import React from "react";
import Usecase7 from "/Images/Usecase7.svg";
import Usecase8 from "/Images/Usecase8.svg";
import Usecase9 from "/Images/Usecase9.svg";
import Usecase10 from "/Images/Usecase10.svg";
import Usecase11 from "/Images/Usecase11.svg";
import Usecase12 from "/Images/Usecase12.svg";
import { useMediaQuery } from "@mui/material";

const BenefitsSection = () => {
  const isMobile = useMediaQuery("(max-width: 767px)");

  const styles = {
    container: {
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: "#E0DCD9",
      padding: isMobile ? "20px" : "100px",
      paddingTop: isMobile ? "40px" : "100px",
      borderRadius: "10px",
      margin: "0 auto", // Pusatkan kontainer di halaman
    },
    header: {
      textAlign: "center",
      marginBottom: isMobile ? "30px" : "60px",
      fontSize: isMobile ? "24px" : "40px",
      background: "linear-gradient(90deg, #2D669B 0%, #0582CA 100%)",
      WebkitBackgroundClip: "text",
      backgroundClip: "text",
      color: "transparent",
      fontWeight: "bold",
    },
    gridContainer: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "repeat(2, 1fr)", // 1 kolom di mobile, 2 di desktop
      gap: isMobile ? "20px" : "40px",
    },
    listItem: {
      display: "flex",
      alignItems: "flex-start",
      gap: "20px",
    },
    icon: {
      width: isMobile ? "40px" : "48px",
      height: isMobile ? "40px" : "48px",
    },
    textContainer: {
      display: "flex",
      flexDirection: "column",
    },
    title: {
      fontWeight: "600",
      fontSize: isMobile ? "16px" : "18px",
      color: "#214D73",
      marginBottom: "8px",
    },
    description: {
      fontSize: isMobile ? "14px" : "16px",
      color: "#6D6D6D",
      lineHeight: "1.5",
      textAlign:"left"
    },
  };

  const benefitsData = [
    {
      icon: Usecase7,
      title: "Enhanced Transaction Transparency",
      description:
        "Tennet leverages blockchain technology to ensure all transactions are traceable and verifiable, fostering trust in institutional relationships.",
    },
    {
      icon: Usecase8,
      title: "Regulatory Compliance",
      description:
        "Our services adhere to strict regulatory standards, offering peace of mind for institutions needing compliance with local and international financial laws.",
    },
    {
      icon: Usecase9,
      title: "24/7 Asset Monitoring",
      description:
        "Enjoy round-the-clock monitoring of your assets with real-time reporting, giving institutions full visibility and control over their digital holdings.",
    },
    {
      icon: Usecase10,
      title: "Dedicated Client Support",
      description:
        "Tennet offers a dedicated support team, ensuring that institutional clients have access to expert assistance whenever needed.",
    },
    {
      icon: Usecase11,
      title: "Scalable Solutions",
      description:
        "Our services are designed to scale with your institution, whether you're a small firm or a large enterprise. Tennet provides flexible and adaptable solutions.",
    },
    {
      icon: Usecase12,
      title: "Seamless Integration",
      description:
        "Tennet's platform is built for easy integration with your existing financial systems, enabling smooth transitions and minimal disruption to your operations.",
    },
  ];

  return (
    <div style={styles.container}>
      <h2 style={styles.header}>
        Benefits of Tennet’s Services <br /> for Institutions
      </h2>
      <div style={styles.gridContainer}>
        {benefitsData.map((benefit, index) => (
          <div key={index} style={styles.listItem}>
            <img src={benefit.icon} alt={benefit.title} style={styles.icon} />
            <div style={styles.textContainer}>
              <span style={styles.title}>{benefit.title}</span>
              <p style={styles.description}>{benefit.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BenefitsSection;
